import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { task } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface FetchTaskByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchTaskByIdApiQuery extends ApiQuery<
	TaskOutput,
	FetchTaskByIdParams
> {
	client = 'iam';
	document = gql`
		query FetchTaskById($id: UUID!) {
			fetchTaskById(id: $id) {
				...Task
			}
		}
		${task}
	`;
	method = 'fetchTaskById';
}
